/** Whether this frontend build targets the dedicated enterprise deployment. */
export function isEnterpriseDeployment(): boolean {
  return process.env.NEXT_PUBLIC_APP_ENV === 'enterprise'
}
